module.exports = __webpack_public_path__ + "media/images/posts/flower_reuse-3c30ace97298ceabeff2543f7227b7d4.jpg";